import React, {useEffect, useMemo, useState} from "react";
import "./../../utils/Style/pages/CardsSettings.scss";
import {useTable, usePagination} from "react-table";
import Table from "../../components/Table";
import {faArrowDown, faEllipsisVertical} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import ActivationToggle from "../../components/CardsSettings/ActivationToggle";
import useCardsAPI from "../../api/CardsAPI";
import {capitalizeFirstLetters, formatAccount, NumberToStringWithSpaces} from "../../features/ValueFormater";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import CancelCardModal from "../../components/CardsSettings/CancelCardModal";
import TableSkeleton from "../../components/skeletons/TableSkeleton";


function CardsSettingsTemplate({setActiveButton}) {
    const [activeRowIndex, setActiveRowIndex] = useState(-1);
    const [cardView, setCardView] = useState(false);
    const [cancelCardInfo, setCancelCardInfo] = useState({
        cardId: null,
        isOpen: false,
        setIsOpen: null,
        message: null,
    });

    const {GetCorporateCard, corporateCards, cardsLoading} = useCardsAPI();

    const navigate = useNavigate();

    const {flag} = useSelector((state) => state.transferResponse);

    useEffect(() => {
        GetCorporateCard();
    }, []);

    useEffect(() => {
        if ([0, 1].includes(flag))
            GetCorporateCard();
    }, [flag]);

    const columns = useMemo(
        () => [
            {
                Header: "Card Name",
                accessor: "CardName",
            },
            {
                Header: "Limit Per Month",
                accessor: "LimitPerMonth",
                Cell: ({value}) => {
                    return formatAccount(value, 1);
                }
            },
            {
                Header: "",
                accessor: "details",
                Cell: ({row}) => {
                    return <button className="showmore" onClick={() => {
                        setActiveRowIndex(row.index)
                    }}><FontAwesomeIcon icon={faArrowDown}/></button>
                },
            },
            {
                Header: "Limit Per Transaction",
                accessor: "LimitPerTransaction",
                Cell: ({value}) => {
                    return formatAccount(value, 1);
                }
            },
            {
                Header: "Cash Withdrawals",
                accessor: "CashWithdrawals",
            },
            {
                Header: "Online Payments",
                accessor: "OnlinePayments",
            },
            {
                Header: "POS Payments",
                accessor: "POSPayments",
            },
            {
                Header: "Active Card",
                accessor: "IsActiveCard",
                Cell: ({row, value}) => {
                    if (row.original.Status.toLowerCase().includes("pending")) {
                        return <div className="pending">Pending</div>
                    } else {
                        return (<ActivationToggle cardId={row.original.CardID} isActive={value}/>)
                    }
                },
            },
            {
                Header: "",
                accessor: "Settings",
                Cell: ({row}) => {
                    if(row.original.Status.toLowerCase().includes("pending")){
                        return <></>
                    }
                    return (
                        <div className="btn-group">
                            <button
                                type="button"
                                data-bs-toggle={row.original.IsActiveCard ? "dropdown" : ""}
                                aria-haspopup="true"
                                aria-expanded="false"
                            ><FontAwesomeIcon id="setingsIcon" icon={faEllipsisVertical}/>
                            </button>
                            <ul className="dropdown-menu">
                                <li>
                                    <button className="dropdown-item" onClick={
                                        () => navigate(`/cardtransactions/${row.original.CardID}`)
                                    }>View Statement
                                    </button>
                                </li>
                                <li>
                                    <button className="dropdown-item" onClick={
                                        () => setActiveButton({name: "Request Card", card: row.original})
                                    }>Edit
                                    </button>
                                </li>
                                <li>
                                    <button className="dropdown-item cancel-card-btn"
                                            onClick={() => {
                                                setCancelCardInfo({
                                                    cardId: row.original.CardID,
                                                    isOpen: true,
                                                    setIsOpen: setCancelCardInfo,
                                                    message: row.original.CardName,

                                                })
                                            }}
                                    >Cancel Card
                                    </button>
                                </li>
                            </ul>
                        </div>

                    )
                },
            }
        ],
        [corporateCards]
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow
    } = useTable({columns, data: corporateCards || []}, usePagination);

    return (
        <div className="row">
            <div className="col-lg-10 col-md-12 Filtering">
                <div></div>
                <div className="Filter">
                    <div className="RequestCard">
                        <button onClick={() => {
                            setActiveButton({name: "Request Card"})
                        }}>Request Card
                        </button>
                    </div>
                    <button className={cardView ? "display" : "display selected"} onClick={() => {
                        setCardView(false)
                    }}>
                        <img src={cardView ? "Images/tableView-grey.png" : "Images/tableView.png"} width="50%"/>
                    </button>
                    <button className={!cardView ? "display" : "display selected"} onClick={() => {
                        setCardView(true)
                    }}>
                        <img src={!cardView ? "Images/cardView.png" : "Images/cardView-white.png"} width="50%"/>
                    </button>
                </div>
            </div>

            {
                !cardsLoading ?
                    <>
                        {!cardView &&
                            <div className="col-lg-10 col-md-12">
                                <Table
                                    headerGroups={headerGroups}
                                    page={rows}
                                    prepareRow={prepareRow}
                                    getTableProps={getTableProps}
                                    getTableBodyProps={getTableBodyProps}
                                    activeRowIndex={activeRowIndex}
                                    setActiveRowIndex={setActiveRowIndex}
                                />
                            </div>
                        }

                        {cardView &&
                            <>
                                <div className="col-12 CardViewDisplay">
                                    <div className="row">
                                        {corporateCards.map((card, index) => (
                                            <div
                                                className={card.IsActiveCard ? "col-lg-3 col-md-4 col-sm-6 cardView" : "col-lg-3 col-md-4 col-sm-6 cardView inactive-card-view"}
                                                key={index}>
                                                <div className="row cardHeader">
                                                    <div className="col-7 username">{card.CardName}</div>
                                                </div>
                                                <div className="row cardBody">
                                                    <div className="col-4">
                                                        <img src="/Images/suyool-card.png"/>
                                                        <p className="card-number">{NumberToStringWithSpaces(card.CardNumber)}</p>
                                                    </div>
                                                    <div className="col-8 mainBody">
                                                        <div
                                                            className="balance">{formatAccount(card.LimitPerTransaction, 1)}</div>
                                                        <div className="text">Limit Per Transaction</div>
                                                        <div
                                                            className="balance">{formatAccount(card.LimitPerMonth, 1)}</div>
                                                        <div className="text">Limit Per Month</div>
                                                        <div className="row titles">
                                                            <div className="col-4 title">Currency</div>
                                                            <div className="col-4 title">Exp</div>
                                                            <div className="col-4 title">Status</div>
                                                        </div>
                                                        <div className="row description">
                                                            <div className="col-4 desc">{card?.Currency}</div>
                                                            <div
                                                                className="col-4 desc">{card?.ExpiryDate || "12/2023"}</div>
                                                            <div
                                                                className={card.Status.toLowerCase().includes("pending")? "col-4 desc pending": "col-4 desc"}>{capitalizeFirstLetters(card?.Status) || "Active"}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row cardFooter">
                                                    <div className="col-4 btnn">
                                                        <button
                                                            onClick={() => setActiveButton({
                                                                name: "Request Card",
                                                                card: card
                                                            })}
                                                        >Card Settings
                                                        </button>
                                                    </div>
                                                    <div className="col-8 btnn">
                                                        <button onClick={
                                                            () => navigate(`/cardtransactions/${card.CardID}`)
                                                        }>View Statement
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}

                                        <div className="col-lg-2 col-md-3 col-sm-5 requestCard">
                                            <button onClick={() => setActiveButton({name: "Request Card"})}>+Request New
                                                Card
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                    </> : <TableSkeleton/>
            }

            <CancelCardModal cardId={cancelCardInfo.cardId}
                             isOpen={cancelCardInfo.isOpen}
                             message={cancelCardInfo.message}
                             setData={setCancelCardInfo}
            />
        </div>
    );
}

export default CardsSettingsTemplate;